import * as firebase_auth from "firebase/auth";
import * as firebase_app from "firebase/app";

// A config for the Vika app main Firebase project
const appFirebaseConfig = {
  apiKey: "AIzaSyD9WHbF0gRd5-JBufNuzTKJU5ZveumNQHw",
  authDomain: "life-pal-euu.firebaseapp.com",
  databaseURL: "https://life-pal-euu.firebaseio.com",
  projectId: "life-pal-euu",
  storageBucket: "life-pal-euu.appspot.com",
  messagingSenderId: "263075766438",
  appId: "1:263075766438:web:be083ca5351e95b71b9467",
  measurementId: "G-RPZECPLTMV",
};

const firebaseApp = firebase_app.initializeApp(appFirebaseConfig, "lifePalApp");
const firebaseAuth = firebase_auth.getAuth(firebaseApp);

export interface FoundUserLookupResult {
  readonly status: "found";

  readonly accountCreationTime: Date | null;

  delete(): Promise<void>;
}

export interface NotFoundUserLookupResult {
  readonly status: "notFound";
}

export type UserLookupResult = FoundUserLookupResult | NotFoundUserLookupResult;

class UserLookupService {
  async lookupUser(
    authCredential: firebase_auth.AuthCredential,
  ): Promise<UserLookupResult> {
    const userCredential = await firebase_auth.signInWithCredential(
      firebaseAuth,
      authCredential,
    );

    const additionalUserInfo =
      firebase_auth.getAdditionalUserInfo(userCredential);

    if (additionalUserInfo?.isNewUser === true) {
      await firebase_auth.deleteUser(userCredential.user);

      return {
        status: "notFound",
      };
    } else {
      const accountCreationTimeString =
        userCredential.user.metadata.creationTime;
      const accountCreationTime =
        accountCreationTimeString !== undefined
          ? new Date(accountCreationTimeString)
          : null;

      return {
        status: "found",
        accountCreationTime,
        delete(): Promise<void> {
          return firebase_auth.deleteUser(userCredential.user);
        },
      };
    }
  }
}

export const userLookupService = new UserLookupService();
